import { CallState, LoadingState } from 'src/app/utilities/state.util';

export const NEW_OPPORTUNITY_STEPS = ['customer', 'locations', 'inventory', 'workorders'] as const;

export type NewOpportunityStep = typeof NEW_OPPORTUNITY_STEPS[number];
export type ControlMetaStatus = 'VALID' | 'INVALID' | 'PENDING' | 'DISABLED';

export interface ControlMeta {
    dirty: boolean;
    touched: boolean;
    status: ControlMetaStatus;
    invalid: boolean;
    errors: Record<string, any> | null;
    disabled: boolean;
    lastUpdated: number;
}

export type NewOpportunityState = typeof newOpportunityInitialState;

export const NEW_OPPORTUNITY_STEP_TITLES: Record<NewOpportunityStep, string> = {
    customer: 'Customer Details',
    locations: 'Location Details',
    inventory: 'Inventory',
    workorders: 'Workorders',
};

export const newOpportunityInitialState = {
    step: 'customer' as NewOpportunityStep,
    controlMeta: {} as Record<string, ControlMeta>,
    createJobCall: LoadingState.INIT as CallState,
    createJobWithMissingLocationDataConfirmed: false as boolean,
    locationsStepMinimalView: true as boolean,
};
